module.exports = __webpack_public_path__ + "assets/img/image-57-640.49fd00a1.webp";